import {  postGet,postGetUpLoad,post  } from "@/axios"

const api1 ='/torchV'
export const getFileList=(p) => postGet(api1+'/fileList',p)

export const fileImport=(p) => postGetUpLoad(api1+'/fileImport',p)

export const fileDelete=(p) => postGet(api1+'/fileDelete',p)

export const remainStorage=(p) => post(api1+'/remainStorage?companyId='+p.companyId,[])
